import { isEmpty } from 'lodash';

export function isNotEmpty<T>(value: T | null | undefined): value is T {
	return !isEmpty(value);
}

export function assertDefined<T>(value: T | null | undefined): T {
	if (!isNotEmpty(value)) {
		throw new Error('Value is null or undefined');
	}
	return value;
}
